export function isFsUri(value) {
  return value.startsWith('file:///');
}